/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { hideModal } from '../../actions/actions';
import HelpdeskModal from './helpdesk.modal';

export const mapStateToProps = (state, ownProps) => {
  return {
    helpdeskError: state.helpdesk.error
  };
};

export const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeModal: () => {
      dispatch(hideModal());
    }
  };
};

const HelpdeskModalContainer = connect(mapStateToProps, mapDispatchToProps)(HelpdeskModal);

export default HelpdeskModalContainer;
